export default __webpack_public_path__ + "static/media/interface_statistics.43e88593.svg";